import { MULTI_SELECT_CF_TYPE } from '@atlassian/jira-platform-field-config';
import type { DataTransformFn } from '../../../bulk-edit-transform/types';
import type { JiraMultipleSelectField as MultiSelectField } from '../fragment';
import type { MultiSelectFormData } from './types';

export const transformMultiSelectFieldForOptimisticUpdates: DataTransformFn<
	MultiSelectField,
	MultiSelectFormData
> = (existingField: MultiSelectField, fieldData: MultiSelectFormData): MultiSelectField => ({
	...existingField,
	selectedOptions: {
		__typename: 'JiraOptionConnection',
		edges: fieldData.map((field) => ({
			__typename: 'JiraOptionEdge',
			node: { __typename: 'JiraOption', optionId: '', value: field.value },
		})),
	},
});

export const multiSelectOptimisticUpdatesHandler: {
	[key: string]: DataTransformFn<MultiSelectField, MultiSelectFormData>;
} = {
	[MULTI_SELECT_CF_TYPE]: transformMultiSelectFieldForOptimisticUpdates,
};
